import { Menu, Bell, User } from 'lucide-react';
import { useAuthStore } from '../../hooks/useAuth';

export default function Header() {
  const { user, signOut } = useAuthStore();

  return (
    <header className="sticky top-0 z-40 bg-zinc-900/80 backdrop-blur-sm border-b border-zinc-800">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Mobile menu button */}
        <button className="lg:hidden p-2 rounded-lg hover:bg-zinc-800 transition-colors">
          <Menu className="w-5 h-5" />
        </button>

        {/* Search - placeholder */}
        <div className="flex-1 max-w-md mx-4">
          <div className="relative">
            <input
              type="text"
              placeholder="Search personas, projects..."
              className="w-full px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-sm placeholder-zinc-500 focus:outline-none focus:border-jelly-500 transition-colors"
            />
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-4">
          <button className="p-2 rounded-lg hover:bg-zinc-800 transition-colors relative">
            <Bell className="w-5 h-5" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-jelly-500 rounded-full"></span>
          </button>

          <div className="relative group">
            <button className="flex items-center gap-2 p-2 rounded-lg hover:bg-zinc-800 transition-colors">
              <div className="w-8 h-8 bg-jelly-600 rounded-full flex items-center justify-center">
                <User className="w-4 h-4" />
              </div>
              <span className="hidden sm:block text-sm">{user?.email?.split('@')[0] || 'User'}</span>
            </button>

            {/* Dropdown */}
            <div className="absolute right-0 mt-2 w-48 bg-zinc-800 border border-zinc-700 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
              <div className="p-3 border-b border-zinc-700">
                <p className="text-sm font-medium">{user?.email}</p>
              </div>
              <div className="p-2">
                <button
                  onClick={signOut}
                  className="w-full px-3 py-2 text-left text-sm text-red-400 hover:bg-zinc-700 rounded-lg transition-colors"
                >
                  Sign out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
